import { render, staticRenderFns } from "./StepFour.vue?vue&type=template&id=2f67beda&scoped=true&"
import script from "./StepFour.vue?vue&type=script&lang=js&"
export * from "./StepFour.vue?vue&type=script&lang=js&"
import style0 from "./StepFour.vue?vue&type=style&index=0&id=2f67beda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f67beda",
  null
  
)

export default component.exports